import { Routes } from '@angular/router';
import { Home } from './home/home';
import { BookinggroupListComponent } from './config/bookinggroup/bookinggroup-list/bookinggroup-list.component';
import { BookinggroupEditableComponent } from './config/bookinggroup/bookinggroup-editable/bookinggroup-editable.component';
import { BookingdefinitionListComponent } from './config/bookingdefinition/bookingdefinition-list/bookingdefinition-list.component';
import { BookingdefinitionEditableComponent } from './config/bookingdefinition/bookingdefinition-editable/bookingdefinition-editable.component';
import { JournalprocessdefinitionListComponent } from './config/journalprocessdefinition/journalprocessdefinition-list/journalprocessdefinition-list.component';
import { JournalprocessdefinitionEditableComponent } from './config/journalprocessdefinition/journalprocessdefinition-editable/journalprocessdefinition-editable.component';
import { BookingruleEditableComponent } from './config/bookingrule/bookingrule-editable/bookingrule-editable.component';
import { BookingruleListComponent } from './config/bookingrule/bookingrule-list/bookingrule-list.component';
import { GeneralledgerListComponent as ConfigGeneralledgerListComponent } from './config/generalledger/generalledger-list/generalledger-list.component';
import { GeneralledgerEditableComponent } from './config/generalledger/generalledger-editable/generalledger-editable.component';
import { redirectWhenYfSsidExistsGuard, requireYfSsidGuard, rootHomeRedirectGuard, configHomeRedirectGuard, procesHomeRedirectGuard } from './locallogin/login.guard';
import { LoginInformationComponent } from './locallogin/login-information/login-information.component';
import { LoginComponent } from './locallogin/login/login.component';
import { TestDropdownComponent } from './test/test-dropdown.component';
import { GeneralledgeraccountListComponent } from './config/generalledgeraccount/generalledgeraccount-list/generalledgeraccount-list.component';
import { GeneralledgeraccountEditableComponent } from './config/generalledgeraccount/generalledgeraccount-editable/generalledgeraccount-editable.component';
import { GeneralledgergroupEditableComponent } from './config/generalledgergroup/generalledgergroup-editable/generalledgergroup-editable.component';
import { GeneralledgergroupListComponent } from './config/generalledgergroup/generalledgergroup-list/generalledgergroup-list.component';
import { NotimplementedComponent } from './config/notimplemented/notimplemented.component';
import { ExportprocessingComponent } from './proces/exportprocessing/exportprocessing/exportprocessing.component';
import { OverviewJournalEntryComponent } from './proces/overviewjournalentry/overviewjournalentry/overviewjournalentry.component';
import { JobprocessListComponent } from './proces/jobs/jobprocess-list/jobprocess-list.component';
import { JobprocessEditableComponent } from './proces/jobs/jobprocess-editable/jobprocess-editable.component';
import { CreatebireportListComponent } from './proces/exportprocessing/createbireport/createbireport-list/createbireport-list.component';
import { CreatebireportEditableComponent } from './proces/exportprocessing/createbireport/createbireport-editable/createbireport-editable.component';
import { SelectpayrolljournalComponent } from './proces/export/exportgeneralledger/selectpayrolljournal/selectpayrolljournal.component';
import { CreategeneralledgerComponent } from './proces/export/exportgeneralledger/creategeneralledger/creategeneralledger.component';
import { DownloadgeneralledgerComponent } from './proces/export/exportgeneralledger/downloadgeneralledger/downloadgeneralledger.component';
import { JournalprocesslogComponent } from './proces/export/exportgeneralledger/journalprocesslog/journalprocesslog.component';
import { ExportdefinitionListComponent } from './config/exportdefinition/exportdefinition-list/exportdefinition-list.component';
import { ExportdefinitionEditableComponent } from './config/exportdefinition/exportdefinition-editable/exportdefinition-editable.component';
import { redirectWhenTenantOnboardedGuard, requireOnboardedTenantGuard } from './notonboarded/notonboarded.guard';

// Lazy loaded to keep the initial bundle within its budget.
const loadExportrubriekList = () =>
    import('./config/exportrubriek/exportrubriek-list/exportrubriek-list.component').then(
        (m) => m.ExportrubriekListComponent,
    );
const loadExportrubriekEditable = () =>
    import('./config/exportrubriek/exportrubriek-editable/exportrubriek-editable.component').then(
        (m) => m.ExportrubriekEditableComponent,
    );
const loadEmploymentselectionList = () =>
    import('./config/selection/employment/employmentselection-list/employmentselection-list.component').then(
        (m) => m.EmploymentselectionListComponent,
    );
const loadEmploymentselectionEditable = () =>
    import('./config/selection/employment/employmentselection-editable/employmentselection-editable.component').then(
        (m) => m.EmploymentselectionEditableComponent,
    );
const loadConversiontableList = () =>
    import('./config/selection/conversiontable/conversiontable-list/conversiontable-list.component').then(
        (m) => m.ConversiontableListComponent,
    );
const loadConversiontableEditable = () =>
    import('./config/selection/conversiontable/conversiontable-editable/conversiontable-editable.component').then(
        (m) => m.ConversiontableEditableComponent,
    );
const loadNotonboarded = () =>
    import('./notonboarded/notonboarded.component').then(
        (m) => m.NotonboardedComponent,
    );


export const routes: Routes = [
    {
        path: 'Login',
        component: LoginComponent,
        canActivate: [redirectWhenYfSsidExistsGuard],
    },
    {
        path: 'test',
        component: TestDropdownComponent,
    },
    {
        path: '',
        canActivateChild: [requireYfSsidGuard],
        children: [
            { path: 'notonboarded', loadComponent: loadNotonboarded, canActivate: [redirectWhenTenantOnboardedGuard] },
            {
                path: '',
                canActivateChild: [requireOnboardedTenantGuard],
                children: [
                    { path: '', pathMatch: 'full', component: Home, canActivate: [rootHomeRedirectGuard] },
                    { path: 'Home', component: Home },

                    { path: 'config', pathMatch: 'full', component: Home, canActivate: [configHomeRedirectGuard] },
                    { path: 'proces', pathMatch: 'full', component: Home, canActivate: [procesHomeRedirectGuard] },

                    { path: 'config/home', component: Home },

                    { path: 'config/notimplemented', component: NotimplementedComponent },

                    { path: 'config/generalledger', component: ConfigGeneralledgerListComponent },
                    { path: 'config/generalledger/editable', component: GeneralledgerEditableComponent },
                    { path: 'config/generalledger/editable/:id', component: GeneralledgerEditableComponent },

                    { path: 'config/generalledgergroup', component: GeneralledgergroupListComponent },
                    { path: 'config/generalledgergroup/editable', component: GeneralledgergroupEditableComponent },
                    { path: 'config/generalledgergroup/editable/:id', component: GeneralledgergroupEditableComponent },

                    { path: 'config/generalledgeraccount', component: GeneralledgeraccountListComponent },
                    { path: 'config/generalledgeraccount/editable', component: GeneralledgeraccountEditableComponent },
                    { path: 'config/generalledgeraccount/editable/:id', component: GeneralledgeraccountEditableComponent },
                    { path: 'config/generalledgeraccount/:generalLedgerId', component: GeneralledgeraccountListComponent },

                    { path: 'config/bookinggroup', component: BookinggroupListComponent },            
                    { path: 'config/bookinggroup/editable', component: BookinggroupEditableComponent },
                    { path: 'config/bookinggroup/editable/:id', component: BookinggroupEditableComponent },

                    { path: 'config/bookingdefinition', component: BookingdefinitionListComponent },
                    { path: 'config/bookingdefinition/edit', component: BookingdefinitionEditableComponent },
                    { path: 'config/bookingdefinition/edit/:id', component: BookingdefinitionEditableComponent },
                    { path: 'config/bookingdefinition/:bookingGroupId', component: BookingdefinitionListComponent },

                    { path: 'config/journalprocessdefinition', component: JournalprocessdefinitionListComponent },
                    { path: 'config/journalprocessdefinition/edit', component: JournalprocessdefinitionEditableComponent },
                    { path: 'config/journalprocessdefinition/edit/:id', component: JournalprocessdefinitionEditableComponent },
                    { path: 'config/journalprocessdefinition/:bookingGroupId', component: JournalprocessdefinitionListComponent },

                    { path: 'config/exportdefinition', component: ExportdefinitionListComponent },
                    { path: 'config/exportdefinition/editable', component: ExportdefinitionEditableComponent },
                    { path: 'config/exportdefinition/editable/:id', component: ExportdefinitionEditableComponent },

                    { path: 'config/exportrubriek', loadComponent: loadExportrubriekList },
                    { path: 'config/exportrubriek/editable', loadComponent: loadExportrubriekEditable },
                    { path: 'config/exportrubriek/editable/:id', loadComponent: loadExportrubriekEditable },
                    { path: 'config/employmentselection', loadComponent: loadEmploymentselectionList },

                    { path: 'config/selection/employment/employmentselection-list', loadComponent: loadEmploymentselectionList },
                    { path: 'config/selection/employment/employmentselection-editable', loadComponent: loadEmploymentselectionEditable },
                    { path: 'config/selection/employment/employmentselection-editable/:id', loadComponent: loadEmploymentselectionEditable },

                    { path: 'config/conversiontable', loadComponent: loadConversiontableList },
                    { path: 'config/selection/conversiontable/conversiontable-list', loadComponent: loadConversiontableList },
                    { path: 'config/selection/conversiontable/conversiontable-editable', loadComponent: loadConversiontableEditable },
                    { path: 'config/selection/conversiontable/conversiontable-editable/:id', loadComponent: loadConversiontableEditable },

                    { path: 'config/bookingrule', component: BookingruleListComponent },
                    { path: 'config/bookingrule/edit', component: BookingruleEditableComponent },
                    { path: 'config/bookingrule/edit/:id', component: BookingruleEditableComponent },
                    { path: 'config/bookingrule/:bookingGroupId', component: BookingruleListComponent },

                    { path: 'config/generalledger', component: ConfigGeneralledgerListComponent },
                    { path: 'config/generalledger/editable', component: GeneralledgerEditableComponent },
                    { path: 'config/generalledger/editable/:id', component: GeneralledgerEditableComponent },

                    { path: 'LoginInfo', component: LoginInformationComponent },

                    { path: 'proces/home', component: Home },

                    { path: 'proces/notimplemented', component: NotimplementedComponent },            

                    { path: 'proces/exportprocessing', component: ExportprocessingComponent },
                    { path: 'proces/exportprocessing/createbireport', component: CreatebireportListComponent },
                    { path: 'proces/exportprocessing/createbireport/editable/:importRunId', component: CreatebireportEditableComponent },
                    { path: 'proces/export/exportgeneralledger/selectpayrolljournal', component: SelectpayrolljournalComponent },
                    { path: 'proces/export/exportgeneralledger/creategeneralledger/:importRunId', component: CreategeneralledgerComponent },
                    { path: 'proces/export/exportgeneralledger/downloadgeneralledger', component: DownloadgeneralledgerComponent },
                    { path: 'proces/export/exportgeneralledger/journalprocesslog', component: JournalprocesslogComponent },
                    { path: 'proces/overviewjournalentry', component: OverviewJournalEntryComponent },
                    { path: 'proces/jobs', component: JobprocessListComponent },
                    { path: 'proces/jobs/editable', component: JobprocessEditableComponent },
                    { path: 'proces/jobs/editable/:id', component: JobprocessEditableComponent },
            
                    {
                      path: 'yds-angular-docs',
                      loadComponent: () => import('./yds-angular/docs/yds-angular-docs-shell.component').then(m => m.YdsAngularDocsShellComponent),
                      loadChildren: () => import('./yds-angular/docs/yds-angular-docs.routes').then(m => m.YDS_ANGULAR_DOCS_ROUTES),
                    },
                    { path: '**', redirectTo: 'Home' },
                ],
            },
        ],
    }
];
